import { render, staticRenderFns } from "./Profile.template.vue?vue&type=template&id=0ecc2a28&scoped=true&"
var script = {}
import style0 from "./Profile.template.vue?vue&type=style&index=0&id=0ecc2a28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc2a28",
  null
  
)

export default component.exports